/* eslint-disable react-hooks/exhaustive-deps */
import PropTypes from 'prop-types';
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import AppStoreButton from '../../UI/AppStoreButtons/AppStoreButton';
import classes from './GeneralSection.module.css';

import { parseTextWithNewLineToElement } from '../../../utils';
import googleAnalytics from '../../../utils/googleAnalytics';

const GeneralSection = ({ section }) => {
  const { contents } = section;
  const { pathname } = useLocation();
  const hub = useSelector((state) => state.hub.hub);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  const [{ Src, thumbnail, media, storeButtons, button, description, title }] =
    contents;
  let link;

  if (media === null && Src === null) {
    link = '#';
    console.log('no');
    if (button !== null && button?.buttonAtImage) link = button.link;
  } else if (media !== null) {
    link = media.url;
  } else {
    link = Src.link;
  }

  return (
    <div className={classes.container}>
      <span className={classes.title}>{title}</span>
      <div className={classes.body}>
        <div className={classes.images}>
          {link === '#' ? (
            <img
              alt="main"
              className={classes.mainImage}
              src={thumbnail[0].url}
            />
          ) : (
            <a
              target="_blank"
              href={link}
              rel="noreferrer"
              onClick={() => {
                googleAnalytics({
                  event: 'outboundLink',
                  link_url: link,
                  link_title: link,
                  section_title: hub.name,
                });
              }}
            >
              <img
                alt="main"
                className={classes.mainImage}
                src={thumbnail[0].url}
              />
            </a>
          )}

          {storeButtons !== null && <AppStoreButton links={storeButtons} />}
        </div>
        <div className={classes.description}>
          <div className={classes.information}>
            {parseTextWithNewLineToElement(description)}
          </div>
          {button !== null && (
            <a
              href={button.link}
              className={classes.buttonAction}
              target="_blank"
              rel="noreferrer"
              onClick={() => {
                googleAnalytics({
                  event: 'outboundLink',
                  link_url: button.link,
                  link_title: button.label,
                  section_title: hub.name,
                });
              }}
            >
              {button.label}
            </a>
          )}
        </div>
      </div>
    </div>
  );
};

GeneralSection.propTypes = {
  section: PropTypes.shape({
    contents: PropTypes.arrayOf(
      PropTypes.shape({
        title: PropTypes.string,
        description: PropTypes.string,
        imageSrc: PropTypes.string,
        button: PropTypes.shape({
          label: PropTypes.string,
          link: PropTypes.string,
        }),
        storeButtons: PropTypes.shape({}),
      })
    ),
  }).isRequired,
};

export default GeneralSection;
